import React from "react"
import { useToggle } from "utils/Hooks"
/* eslint-disable import/no-restricted-paths */
import AccordionMarkdown from "./AccordionMarkdown"
/* eslint-enable import/no-restricted-paths */
import { Spacer } from "./atoms/Atoms"
import { useIntl } from "react-intl"

const Accordion = ({ title, body, backgroundColor }) => (
  <AccordionWithoutMarkdown title={title} backgroundColor={backgroundColor}>
    <AccordionMarkdown source={body} additionalClasses="pt3 ph3 black-60" />
  </AccordionWithoutMarkdown>
)

const Chevron = ({ expanded, height, disabled }) => {
  const intl = useIntl()
  return (
    <button
      aria-label={intl.formatMessage({ defaultMessage: "view expenses" })}
      style={{ background: "none", border: "none" }}
      className="flex-none mr2 pointer"
    >
      <img
        className={`animate-all vmid ${expanded && "rotate-180"} ${disabled && "o-0"}`}
        alt=""
        src={`/images/icn-disclose-open.svg`}
        height={height}
      />
    </button>
  )
}

export const AccordionWithoutMarkdown = ({
  title,
  children,
  backgroundColor,
  shouldExpand = false,
  disabled = false,
  chevronHeight = 12,
  chevronOnRight = false,
  onClick = null
}) => {
  const [expanded, toggleExpanded] = useToggle(shouldExpand)

  return (
    <div className={`${backgroundColor ? backgroundColor : "bg-white"} animate-all`}>
      {/* Only making top clickable, as making expandable section clickable disallows selecting its contents */}
      <div
        className="flex pointer carrot-orange hover-black"
        onClick={() => {
          if (!disabled) {
            toggleExpanded()
            onClick && onClick(!expanded)
          }
        }}
      >
        {!chevronOnRight && <Chevron expanded={expanded} height={chevronHeight} disabled={disabled} />}
        <div className="flex-auto">
          <div className={`black-80 publico-text normal f4 ${disabled || "dim"}`}>{title}</div>
        </div>
        {chevronOnRight && <Chevron expanded={expanded} height={chevronHeight} disabled={disabled} />}
      </div>

      {expanded && !disabled && children}
      <Spacer height={1} />
    </div>
  )
}

export default Accordion
